import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import ConfirmBox from "../common/ConfirmBox";

const ExitExamButton = ({ message, styles }) => {
  const navigate = useNavigate();

  const [showBox, setShowBox] = useState(false);

  const handleStart = () => {
    setShowBox(true);
  };

  const handleBackDrop = () => {
    setShowBox(false);
  };

  const handleCancel = () => {
    setShowBox(false);
  };

  const handleConfirm = () => {
    setShowBox(false);
    navigate("/client/topics");
  };

  return (
    <div>
      <button
        type="button"
        onClick={handleStart}
        className={`${styles} h-[36px] rounded-md text-sm px-[32px] font-semibold`}
      >
        {message}
      </button>
      {showBox && (
        <ConfirmBox
          onBackDrop={handleBackDrop}
          onConfirm={handleConfirm}
          onCancel={handleCancel}
          message="exit"
        />
      )}
    </div>
  );
};

export default ExitExamButton;
